var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_17_319",
    transform: "scale(0.0322581 0.0434783)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_17_319",
    width: 31,
    height: 23,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAXCAYAAADz/ZRUAAACbklEQVRIibWWX2jOYRTHPy/LZBFbZFuaP0VtyoVkFK1YudSEpSQXUsyfZhcuNk3iQuTSRi7cuPHnZhGXQzEkGTV/Qki5WVjLv9lXZ52Xn1/7vb/fz/u+p07v+3zPeZ7v85xzfud5kFQsrZN0S/9Kr6TFWb4JFEc2AE+AOUA7sNl/a4B+oGmMtQinXiFpRNKhCHuHpJ+SVmYMKLD0AMNAsy87D5gP9AIjjl0ESo08A7QBDUAtMJrHXuwklcBSYMCxnUCXYw8dWwC8KAGOAQeBz8BZYCH8dy3YvJnAlwB2HjhqJw1gQ0DGcvBd0gNJo5JWFSDnJjWBcamkj5bjAFZlTrbTSR4WC89NT0E+8hxYHZhvaXwGDAawNcDr7E53+462+TiqUpNoh69RFeFb7fZdYXLTJsdOSpqYkrhR0g9JA5KGJbVIKnOb/e5x/KqkkvHITdc6fiYF8Vavm+M+7vI1fkl67N++SXd2ThS5aYMX4wUvmlzE2XS1h/BKSXvd1upjkpCb1rr9Rg7iNvfZZz1jHHuZ28vDtjhy00WS3km6JmlqyNbp4dyYY35e5KYH3O9eIAWnHOuJmRtJnqSTHQFOAIeBycB74CmwH2jxtnkbmJa6N8Sc/Irbt/h4uoe/T9Jyx+ZKGpL0UtKsQoS93Am+SlqW4DMz/7uSvkmqzyfs1cArYLbfPvcTBNBaZz1wHbjz57EQI2HyRrvqgEdAHfAhZRbXe41cBjpjvT0kOyRt8v/nUnS1KG0OrDUlV84/SXrjDtsLQJzVJZIGJfV7LcwI+9hjwh4Sp8euOKgAuv2azUfsdfQW6APWAZf8afVXgN8wvqiIPaMK9gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.07464063072c82876486e537a00cc618.svg";
export { ForwardRef as ReactComponent };